var YMK = YMK || {};
var site = site || {};

(function ($) {
  Drupal.behaviors.productFoundationVtoV1 = {
    attach: function (context) {
      var $productFoundationVto = $('.js-product-foundation-vto-v1', context);

      if (!$productFoundationVto.length) {
        return;
      }
      var autoTriggerYoucam = window.location.href.indexOf('vto_open') !== -1;
      var hasVtoDiscloseParam = window.location.href.indexOf('vto_disclose') !== -1;
      var $foundationVtoButton = $('.js-product-foundation-vto-btn', context);
      var $foundationVtoContainer = $(
        '.js-product-foundation-vto-container',
        $productFoundationVto
      );
      var $mobileShadePickContainer = $(
        '.js-product-foundation-shade-container',
        $productFoundationVto
      );
      var $mobileShadePicker = $('.js-shade-picker-vto', $productFoundationVto);
      var $addToBagButton = $('.js-add-to-cart', $productFoundationVto);
      var $foundationVtoOverlayContainer = $(
        '.js-product-foundation-vto-overlay-container',
        $productFoundationVto
      );
      var foundationOverlayTemplate = $(
        'script.inline-template[path="foundation_vto_overlay"]'
      ).html();

      $foundationVtoOverlayContainer.html(foundationOverlayTemplate);

      // overlay elements
      var $foundationVtoOverlayButton = $(
        '.js-product-foundation-vto-overlay-button',
        $productFoundationVto
      );
      var $foundationVtoIframe = $('.js-product-foundation-vto-iframe', $productFoundationVto);
      var $swatches = $('.js-swatches', $mobileShadePicker);
      var $swatch = $('.js-swatch', $mobileShadePicker);
      var $swatchFilter = $('.js-vto-filter-text', $swatches);
      var $foundationOverlayClose = $(
        '.js-product-foundation-vto-overlay-close',
        $productFoundationVto
      );
      var isMob = site.client.isMobile;
      var youcamAPIKey = Drupal.settings.foundation_vto.api_key;
      var youcamAPIUrl = Drupal.settings.foundation_vto.api_url;
      var language = Drupal.settings.foundation_vto.language;
      var $seeAllshade = $('.js-see-all-shade', $productFoundationVto);
      var $seeMyPerfect = $('.js-see-perfect', $productFoundationVto);
      var $bodyElement = $('body', context);
      var foundationResults = [];
      var shadeSelected = false;
      var youcamEvents = [
        'cameraFailed',
        'cameraOpened',
        'compare',
        'compareDisabled',
        'closed',
        'loaded',
        'loading',
        'kissDetected',
        'opened',
        'photoLoaded',
        'photoSaved',
        'reset',
        'videoLoaded',
        'shadeFinderStarted',
        'shadeFinderCancelled',
        'skinShadeFound',
        'zoom',
        'cameraClosed',
        'engineClosed',
        'modelLoaded',
        'skinAnalysisUpdated',
        'split4Way',
        'split4WayDisabled'
      ];

      if (isMob) {
        var $vtoElement = $foundationVtoContainer.remove();

        $vtoElement.appendTo($bodyElement);
        site.createAddButton($addToBagButton);
        // set height to screen height
        $foundationVtoContainer.height($(window).height());
        $mobileShadePickContainer.addClass('product-foundation-vto__container-shades');
        $(document).on('addToCart.success', function () {
          var addedText = $addToBagButton.data('added-text');
          var addText = $addToBagButton.data('add-text');

          $addToBagButton.html(addedText);
          $addToBagButton.addClass('product-added');
          setTimeout(function () {
            $addToBagButton.html(addText);
            $addToBagButton.removeClass('product-added');
          }, 3000);
        });
      }
      (function (d, k) {
        var s = d.createElement('script');

        s.type = 'text/javascript';
        s.async = true;
        s.src = youcamAPIUrl + k;
        var x = d.getElementsByTagName('script')[0];

        x.parentNode.insertBefore(s, x);
      })(document, youcamAPIKey);

      window.ymkAsyncInit = function (skipEventListener) {
        var productID = $addToBagButton.data('product-id').replace('PROD', '');
        var vtoParams = {
          showCloseBtnOnLauncher: true,
          bottomPanelOffsetY: $mobileShadePickContainer.height() + 5
        };

        $foundationVtoContainer.height($(window).height());
        if (Drupal.settings.foundation_vto.is_product_list_enabled) {
          vtoParams['productIdList'] = [productID];
        }
        if (!!language) {
          vtoParams['language'] = language;
        }
        window.YMK.init(vtoParams);
        if (skipEventListener) {
          return;
        }
        youcamEvents.forEach(function (event) {
          window.YMK.addEventListener(event, function (result, progress) {
            if (event === 'compare' || event === 'compareDisabled') {
              $mobileShadePickContainer.addClass('active');
            } else {
              $mobileShadePickContainer.removeClass('active');
              $swatches.removeClass('vto-filter first-filter active best-match');
              $swatchFilter.html('');
            }
            if (event === 'loaded') {
              // add current sku
              if (isMob) {
                toggleMobileShadePick('on');
              }
            }
            if (event === 'opened' && autoTriggerYoucam) {
              $foundationVtoButton.addClass('hidden');
            }
            if (event === 'closed') {
              if (isMob) {
                toggleMobileShadePick('off');
              }
              closeYoucamModule();
            }
            if (event === 'skinShadeFound') {
              if (result.readableRecommendations) {
                foundationResults = result;
                skinShadeFilter();
                $mobileShadePickContainer.addClass('active');
                $seeMyPerfect.removeClass('active');
                if ($mobileShadePicker.find('.vto-filter').length) {
                  $seeAllshade.addClass('active');
                  $swatches.removeClass('active');
                  changeSKU($mobileShadePicker.find('.vto-filter.best-match .js-swatch'));
                } else {
                  $seeAllshade.removeClass('active');
                  $swatches.addClass('active');
                  changeSKU($mobileShadePicker.find('.js-swatch').first());
                }
              }
            }
            // Youcam analytics tagging
            if (site && site.track) {
              var productName, eventName, skuID;
              var data = site.track.refreshData();

              if (
                data &&
                data.product_name &&
                data.product_name.length &&
                data.product_sku &&
                data.product_sku.length
              ) {
                productName = data.product_name[0].replace(/(<([^>]+)>)/gi, '');
                skuID = data.product_sku[0];
              }
              var selectedSku = $swatch.filter('.selected').attr('data-sku-base-id');

              if (selectedSku && selectedSku !== '') {
                skuID = 'SKU' + selectedSku;
              }
              if (event === 'loading') {
                if (result === 10) {
                  eventName = 'loading';
                } else if (result === 100) {
                  eventName = 'loaded';
                }
              } else {
                eventName = event;
              }
              if (eventName && eventName !== '') {
                site.track.evtLink({
                  event_name: 'vto',
                  event_category: 'youcam',
                  event_action: eventName,
                  event_label: skuID + ' - ' + productName
                });
              }
            }
          });
        });
        if (autoTriggerYoucam) {
          openYoucamModule();
        }
      };

      function skinShadeFilter() {
        if (
          foundationResults.readableRecommendations &&
          foundationResults.readableRecommendations.length
        ) {
          var currentShadeMatchFound = 0;
          var perfectMatch = foundationResults.readableRecommendations[0];

          if (perfectMatch) {
            $swatches.removeClass('vto-filter first-filter best-match');
            $.each(perfectMatch, function (skin) {
              var skinData = perfectMatch[skin];

              if ($.isNumeric(skinData)) {
                return;
              }
              var $shadeElement = $mobileShadePicker
                .find('.js-swatch[data-product-code=' + skinData + ']')
                .closest('.js-swatches');

              if ($shadeElement.length) {
                currentShadeMatchFound = 1;
                var skinText = $productFoundationVto.attr('data-foundation-' + skin);
                var perfectText =
                  skin === 'guid'
                    ? $productFoundationVto.attr('data-foundation-perfect')
                    : skinText;
                var filterClass = skin === 'guid' ? 'best-match vto-filter' : 'vto-filter';

                $shadeElement
                  .addClass(filterClass)
                  .find('.js-vto-filter-text')
                  .html(skinText)
                  .attr('data-filter-text', perfectText);
              }
            });
            $mobileShadePicker.find('.vto-filter').first().addClass('first-filter');
          }
          if (currentShadeMatchFound) {
            $seeMyPerfect.addClass('active');
          } else {
            $seeMyPerfect.removeClass('active');
          }
        }
        $mobileShadePicker.find('.js-swatch').each(function () {
          var $this = $(this);
          var [shadeCode, shadeName] = $this.text()?.split(' ', 2);

          if ($this.find('.js-shade-code').length === 0) {
            $this.html('<span class="shade-code js-shade-code">' + shadeCode + '</span>' + shadeName);
          }
        });
      }

      function chatButtonToggle() {
        var $chatIconContainer = $('.wo-inline', context);
        var $chatIconButton = $chatIconContainer.find('.wo-chat-btn');

        if ($chatIconButton.length) {
          $chatIconButton.toggleClass('hidden');
        }
      }

      function openYoucamModule() {
        var $mobileChatLabel = $('.lt-label-chat');
        var $chatLiveButton = $('.LPMcontainer');

        chatButtonToggle();
        $foundationVtoButton.addClass('hidden');
        $foundationVtoContainer.removeClass('hidden');
        $foundationVtoOverlayContainer.removeClass('hidden');
        if (hasVtoDiscloseParam) {
          $foundationOverlayClose.addClass('hidden');
        }
        $foundationVtoIframe.addClass('hidden');
        autoTriggerYoucam = 0;
        // disable scrolling
        window.scrollTo(0, 0);
        $bodyElement.addClass('no-scroll');
        $chatLiveButton.addClass('hidden');
        $mobileChatLabel.addClass('hidden');
      }

      $foundationVtoOverlayButton.once().on('click', function (e) {
        e.preventDefault();
        var userAgent = navigator.userAgent;
        var iosBrowserErrorCopy = $productFoundationVto.data('ios-browser-error-copy');
        var $overlayContent = $(
          '.js-foundation-vto-overlay-content',
          $foundationVtoOverlayContainer
        );
        var $disclaimerCheck = $('.js-vto-disclaimer-checkbox', $foundationVtoOverlayContainer);
        if ($disclaimerCheck.length > 0 && !$disclaimerCheck.is(':checked')) {
          return;
        }
        $foundationVtoOverlayContainer.addClass('hidden');
        $foundationVtoIframe.removeClass('hidden');
        window.YMK.open(true, null, true);
      });

      $seeAllshade.once().on('click', function (e) {
        e.preventDefault();
        $(this).removeClass('active');
        $seeMyPerfect.addClass('active');
        $swatches.addClass('active');
        $mobileShadePickContainer.removeClass('product-foundation-vto__container-shades');
        $mobileShadePicker.scrollTo($mobileShadePicker.find('a.selected'), {
          duration: 350,
          offset: -40
        });
      });

      $seeMyPerfect.once().on('click', function (e) {
        e.preventDefault();
        $(this).removeClass('active');
        $seeAllshade.addClass('active');
        $swatches.removeClass('active');
        $mobileShadePickContainer.addClass('product-foundation-vto__container-shades');
        changeSKU($mobileShadePicker.find('.vto-filter.best-match .js-swatch'));
      });

      function closeYoucamModule() {
        var $mobileChatLabel = $('.lt-label-chat');
        var $chatLiveButton = $('.LPMcontainer');

        chatButtonToggle();
        $foundationVtoContainer.addClass('hidden');
        $foundationVtoButton.removeClass('hidden');
        $swatches.removeClass('vto-filter first-filter selected active best-match');
        $swatchFilter.html('');
        if (isMob) {
          // enable scrolling
          $bodyElement.removeClass('no-scroll');
          $chatLiveButton.removeClass('hidden');
          $mobileChatLabel.removeClass('hidden');
        }
        // reset youcam module
        window.YMK.closeEngine();
        $mobileShadePickContainer.removeClass('active');
        if (hasVtoDiscloseParam) {
          openYoucamModule();
        }
      }

      $foundationOverlayClose.once().on('click', function (e) {
        e.preventDefault();
        closeYoucamModule();
      });

      function toggleMobileShadePick(state) {
        if (state === 'on') {
          var $activeSwatch = $mobileShadePicker.find('a.selected');

          $mobileShadePickContainer.removeClass('hidden');
          // scroll to active swatch
          $mobileShadePicker.scrollTo($activeSwatch, {
            duration: 350,
            offset: -40
          });
        } else if (state === 'off') {
          $mobileShadePickContainer.addClass('hidden');
        }
      }

      function changeSKU(swatch) {
        if (
          !page_data ||
          !page_data['catalog-spp'] ||
          !Array.isArray(page_data['catalog-spp']['products']) ||
          !swatch.length
        ) {
          return null;
        }
        var skuBaseId = swatch.data('sku-base-id');

        shadeSelected = false;
        var productData = page_data['catalog-spp']['products'][0];
        var skuData = _.find(productData.skus, function (sku) {
          return sku.SKU_BASE_ID === skuBaseId;
        });

        site.skuSelect(skuData);
      }

      $swatch.once().on('click', function () {
        changeSKU($(this));
      });

      $bodyElement.on('sku:select', function (e, skuData) {
        if (shadeSelected) {
          return;
        }
        // update shadename
        var $shadeNameContainer = $('.js-shadename', $mobileShadePickContainer);
        var $shadeSwatchContainer = $('.js-current-swatch', $mobileShadePickContainer);
        // update mobile carousel
        var $curMobSwatch = $mobileShadePickContainer.find(
          'a[data-sku-base-id="' + skuData.SKU_BASE_ID + '"]'
        );

        $mobileShadePickContainer.find('a.js-swatch').removeClass('selected');
        $swatches.removeClass('selected');
        $curMobSwatch.addClass('selected').closest('.swatches--single').addClass('selected');
        $shadeNameContainer.html(skuData.SHADENAME);
        $shadeSwatchContainer.css('background-color', skuData.HEX_VALUE_STRING);
        // change the shade
        if (YMK && YMK.applyMakeupBySku) {
          YMK.applyMakeupBySku(skuData.PRODUCT_CODE);
        }
        // update sku price
        if (Drupal?.settings?.foundation_vto?.is_sku_price_update_enabled) {
          // Product Price Selector
          var $productPrice = $('.product-price', $mobileShadePickContainer);
          // Formatted Price of the selected Sku
          var selectedSkuFormattedPrice = skuData?.formattedPrice || '';
          // Formatted Price 2 of the selected Sku
          var selectedSkuFormattedPrice2 = skuData?.formattedPrice2 || '';
          // Formatted Taxed Price of the selected Sku
          var selectedSkuFormattedTaxedPrice = skuData?.formattedTaxedPrice || '';
          // With Tax Product Translation Text
          var withTax = site.translations.product?.with_tax || '';
          // HTML content for Formatted Price
          var formattedPriceHTMLContent =
            '<span class="sale-price js-formatted-price">' + selectedSkuFormattedPrice + '</span>';
          // HTML content for Formatted Price 2
          var formattedPrice2HTMLContent =
            '<span class="product__price--non-sale js-formatted-price-2">' +
            selectedSkuFormattedPrice2 +
            '</span>';
          // HTML content for Formatted Taxed Price
          var formattedTaxedPriceHTMLContent =
            '<span class="taxed-price js-formatted-taxed-price">' +
            withTax +
            selectedSkuFormattedTaxedPrice +
            '</span>';
          // HTML content for FormattedPrice + FormattedTaxedPrice (Standard Block)
          var standardHTMLContent = formattedPriceHTMLContent + formattedTaxedPriceHTMLContent;

          // Empty .product-price element
          $productPrice.empty();

          // Build dynamically the Price Block accordingly with the current skuData
          if (skuData && skuData?.PRICE2) {
            // Build PRICE2 content
            $productPrice.html(
              formattedPrice2HTMLContent +
                '<span class="product__price--standard">' +
                standardHTMLContent +
                '</span>'
            );
          } else {
            // Build the other block (without PRICE2 Content)
            $productPrice.html(standardHTMLContent);
          }
        }
        if (skuData.VTO_FOUNDATION_ONLINE) {
          $foundationVtoButton.removeClass('hidden');
        } else {
          $foundationVtoButton.addClass('hidden');
        }
        shadeSelected = true;
      });
      $(document).on('change', '.js-vto-disclaimer-checkbox', function (e) {
        var isDisclaimerChecked = $(e.target).is(':checked');
        $foundationVtoOverlayButton.toggleClass('disabled', !isDisclaimerChecked);
      });
      $foundationVtoButton.once().on('click', function (e) {
        e.preventDefault();
        openYoucamModule();
      });
    }
  };
})(jQuery);
